(() => {
  const bound = new WeakSet();
  async function init(scope = document) {
    for (const wall of scope.querySelectorAll('[data-ph44-donor-wall]')) {
      if (bound.has(wall)) continue;
      bound.add(wall);
      const list = wall.querySelector('[data-slip-list]');
      let next = list.dataset.next;
      const seenPages = new Set();
      try {
        while (next && wall.isConnected) {
          const url = new URL(next, location.href);
          if (url.origin !== location.origin || seenPages.has(url.href)) break;
          seenPages.add(url.href);
          url.searchParams.set('section_id', list.dataset.section);
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Donor slips could not load');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const other = doc.querySelector('[data-slip-list]');
          if (!other) throw new Error('Donor slips missing');
          for (const item of other.querySelectorAll('[data-slip]')) list.append(item);
          next = other.dataset.next;
        }
      } catch {
        wall.querySelector('[data-slip-error]').hidden = false;
      }
      const handles = new Set();
      const slips = [...list.querySelectorAll('[data-slip]')].filter(item => {
        if (handles.has(item.dataset.handle)) { item.remove(); return false; }
        handles.add(item.dataset.handle); return true;
      }).sort((a, b) => b.dataset.paidAt.localeCompare(a.dataset.paidAt));
      slips.forEach((item, index) => {
        list.append(item);
        item.hidden = index >= Number(wall.dataset.limit || 6);
        const amount = item.querySelector('[data-slip-amount]');
        try { amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: amount.dataset.currency }).format(Number(amount.dataset.minor) / 100); } catch { /* Keep the currency-code fallback. */ }
      });
      wall.querySelector('[data-slip-empty]').hidden = slips.length > 0;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
